import React, { useState, useEffect } from "react"
import { Map, GoogleApiWrapper, Marker } from "google-maps-react"
import mapMarker from "../../images/map-marker.png"
// import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react"

const GoogleMap = (props) => {
  const [bounds, setBounds] = useState(null)

  const style = {
    width: "100%",
    height: "100%",
  }

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "100%",
  }

  // 3.31497114423, 50.803721015, 7.09205325687, 53.5104033474

  useEffect(() => {
    // let points = [
    //   { lat: 50.803721015, lng: 3.31497114423 }, // SW
    //   { lat: 53.5104033474, lng: 7.09205325687 }, // NE
    //   { lat: 53.5104033474, lng: 3.31497114423 }, // NW
    //   { lat: 50.803721015, lng: 7.09205325687 }, // SE
    // ]

    let points = [
      { lat: 50.803721015, lng: 3.31497114423 }, // SW
      { lat: 53.5104033474, lng: 7.09205325687 }, // NE
      { lat: 53.5104033474, lng: 3.31497114423 }, // NW
      { lat: 50.803721015, lng: 7.09205325687 }, // SE
    ]

    let temp = new props.google.maps.LatLngBounds()

    for (let i = 0; i < points.length; i++) {
      temp.extend(points[i])
    }

    setBounds(temp)
    // eslint-disable-next-line
  }, [])

  const mapStyle = [
    {
      featureType: "administrative.neighborhood",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry",
      stylers: [
        {
          color: "#eeeeee",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#eeeeee",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#e5e5e5",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [
        {
          color: "#dadada",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#9e9e9e",
        },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#c9c9c9",
        },
      ],
    },
  ]

  const _mapLoaded = (mapProps, map) => {
    map.setOptions({
      styles: mapStyle,
      mapTypeControl: false,
      streetViewControl: false,
    })
  }

  return (
    <Map
      google={props.google}
      containerStyle={containerStyle}
      style={style}
      // initialCenter={{
      //   lat: 52.234891,
      //   lng: 5.610818,
      // }}
      bounds={bounds}
      onReady={(mapProps, map) => _mapLoaded(mapProps, map)}
      // zoom={8}
    >
      {props.geolocations.map((loc, idx) => (
        <Marker
          key={idx}
          title={`${loc.lat} + ", " + ${loc.lng}`}
          name={""}
          position={loc}
          icon={{
            url: mapMarker,
            anchor: new props.google.maps.Point(8, 8),
            scaledSize: new props.google.maps.Size(16, 16),
          }}
        />
      ))}

      {/* <Marker
        title={"The marker`s title will appear as a tooltip."}
        name={"SOMA"}
        position={{ lat: 53.5104033474, lng: 3.31497114423 }} // NW
        icon={{
          url: mapMarker,
          anchor: new props.google.maps.Point(8, 8),
          scaledSize: new props.google.maps.Size(16, 16),
        }}
      /> */}

      {/* <Marker
        title={"The marker`s title will appear as a tooltip."}
        name={"SOMA"}
        position={{ lat: 50.803721015, lng: 7.09205325687 }} // SE
        icon={{
          url: mapMarker,
          anchor: new props.google.maps.Point(8, 8),
          scaledSize: new props.google.maps.Size(16, 16),
        }}
      />

      <Marker
        title={"The marker`s title will appear as a tooltip."}
        name={"SOMA"}
        position={{ lat: 53.5104033474, lng: 7.09205325687 }} // NE
        icon={{
          url: mapMarker,
          anchor: new props.google.maps.Point(8, 8),
          scaledSize: new props.google.maps.Size(16, 16),
        }}
      />

      <Marker
        title={"The marker`s title will appear as a tooltip."}
        name={"SOMA"}
        position={{ lat: 50.803721015, lng: 3.31497114423 }} // SW
        icon={{
          url: mapMarker,
          anchor: new props.google.maps.Point(8, 8),
          scaledSize: new props.google.maps.Size(16, 16),
        }}
      /> */}
    </Map>
  )
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyBk-Tz7aFDGeQ9Ou2J8xer_6QFxKK4gCsA",
})(GoogleMap)
